import HttpFactory from '../factory'
import type { Claim } from '../types/claim'

class ClaimsModule extends HttpFactory<any[]> {
  private PATH = '/claims'

  async get(): Promise<Claim[]> {
    let arr: any[] = []
    let nextPageUrl = '?pageSize=200'
    do {
      await this.call<any>('GET', `${this.PATH}${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }
}

export default ClaimsModule
